// extracted by mini-css-extract-plugin
export default {"formItemFlex":"DataPointConfig_formItemFlex__XWLXo"};